import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const searchNotificationEvents = (headers, params) => {
    let query = buildQuery(params, []);
    if (params.filters.idNumber.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    if (params.filters.phoneNumber.value) {
        query += `&phoneNumber=${params.filters.phoneNumber.value?.trim()}`;
    }
    if (params.filters.fromDate.value) {
        query += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params.filters.toDate.value) {
        query += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/notification-events${query}`, { headers });
};
